import { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Container,
  Popover,
  ProfileInfo,
  InfoText,
  Name,
  Email,
  ActionList,
  ActionItem
} from './UserProfileMenu.styles'
import Logout from '../LogoutSupabase/Logout.container'
import routes from '../../config/settings/routes'
import { getAvatarSrc, handleAvatarError } from '../../config/settings/avatar'
import Portal from '../../components/Basics/Portal'
import { useAuthProvider } from '../../modules/Auth/providers/AuthSupabaseProvider/AuthProvider.hook'

const UserProfileMenu = () => {
  const { profile } = useSelector(state => state.adminUserProfile)
  const { signingOut } = useAuthProvider()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const avatarRef = useRef(null)
  const popoverRef = useRef(null)
  const [coords, setCoords] = useState({ top: 0, left: 0 })

  // Toggle popover
  const toggleMenu = () => {
    if (!avatarRef.current) return

    const rect = avatarRef.current.getBoundingClientRect()
    setCoords({
      top: rect.bottom + 8,
      left: rect.right - 220, // ancho del popover
    })

    setOpen(prev => !prev)
  }

  const handlePreferences = () => {
    navigate(routes.preferences)
    setOpen(false)
  }

  const handleHelp = () => {
    navigate(routes.help)
    setOpen(false)
  }

  // Close popover when clicking outside
  useEffect(() => {
    if (!open) return

    const handleClickOutside = (event) => {
      if (
        avatarRef.current &&
        !avatarRef.current.contains(event.target) &&
        popoverRef.current &&
        !popoverRef.current.contains(event.target)
      ) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  return (
    <Container>
      <Avatar
        ref={avatarRef}
        src={getAvatarSrc(profile?.avatarUrl)}
        alt={profile?.fullName}
        referrerPolicy="no-referrer"
        onError={handleAvatarError}
        onClick={toggleMenu}
      />

      {open && !signingOut && (
        <Portal>
          <Popover
            ref={popoverRef}
            top={coords.top}
            left={coords.left}
            onClick={(e) => e.stopPropagation()} // evita cerrar al click dentro
          >
            <ProfileInfo>
              <Avatar
                src={getAvatarSrc(profile?.avatarUrl)}
                alt={profile?.fullName}
                referrerPolicy="no-referrer"
                onError={handleAvatarError}
                style={{ width: 32, height: 32 }}
              />
              <InfoText>
                <Name>{profile?.fullName}</Name>
                <Email>{profile?.email}</Email>
              </InfoText>
            </ProfileInfo>
            <ActionList>
              <ActionItem onClick={handlePreferences}>
                Preferencias
              </ActionItem>
              <ActionItem onClick={handleHelp}>
                Ayuda
              </ActionItem>
              <Logout />
            </ActionList>
          </Popover>
        </Portal>
      )}
    </Container>
  )
}

export default UserProfileMenu
